import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { formatDateTime } from 'src/app/modules/utils/FormatUtils'

type Props = {
    selectedSheetDetail: any
}

const ThongTinPhieuKhamBenh = ({ selectedSheetDetail }: Props) => {
    return (
        <Row className="spaces px-6 pt-4 h-calc-vh-375 overflow-y-auto">

            {/* --- CLINICAL ORDER --- */}
            <Col xs="12">
                <div className="spaces fw-5 mb-8 d-flex">
                    <span className="d-inline-block spaces min-w-130 fw-bold">Dịch vụ:</span>
                    <span className="spaces fw-4 text-truncate">
                        {selectedSheetDetail?.clinicalOrder?.termName || '...'}
                    </span>
                </div>
            </Col>

            <Col xs="6">
                <div className="spaces fw-5 mb-8 d-flex">
                    <span className="d-inline-block spaces min-w-130 fw-bold">Ngày tạo:</span>
                    <span className="spaces fw-4 text-truncate">
                        {selectedSheetDetail?.clinicalOrder?.createdDate ? formatDateTime(selectedSheetDetail?.clinicalOrder?.createdDate) : '...'}
                    </span>
                </div>
            </Col>

            <Col xs="6">
                <div className="spaces fw-5 mb-8 d-flex">
                    <span className="d-inline-block spaces min-w-80 fw-bold">Khoa:</span>
                    <span className="spaces fw-4 text-truncate">
                        {selectedSheetDetail?.clinicalOrder?.fulfillDeptName || '...'}
                    </span>
                </div>
            </Col>

            {/* --- ENCOUNTER DIAGNOSIS --- */}
            <Col xs="12">
                <div className="spaces fw-5 mb-8 d-flex">
                    <span className="d-inline-block spaces min-w-130 fw-bold">Lý do khám:</span>
                    <span className="spaces fw-4 text-truncate">
                        {selectedSheetDetail?.encounterDiagnosis?.reasonForEncounter || '...'}
                    </span>
                </div>
            </Col>

            <Col xs="12">
                <div className="spaces fw-5 mb-8 d-flex">
                    <span className="d-inline-block spaces min-w-130 fw-bold">Chẩn đoán:</span>
                    <span className="spaces fw-4 text-truncate">
                        {
                            selectedSheetDetail?.encounterDiagnosis?.icdXPrimaryName
                            || selectedSheetDetail?.encounterDiagnosis?.yhctPrimaryName
                            || selectedSheetDetail?.encounterDiagnosis?.provisionalDiagnosisName
                            || selectedSheetDetail?.encounterDiagnosis?.diagnosisNonCoded
                            || '...'
                        }
                    </span>
                </div>
            </Col>

            <Col xs="12">
                <div className="spaces fw-5 mb-8 d-flex">
                    <span className="d-inline-block spaces min-w-130 fw-bold">Kết quả:</span>
                    <span className="spaces fw-4 text-truncate">
                        {selectedSheetDetail?.encounterDiagnosis?.medicalConclusionName || '...'}
                    </span>
                </div>
            </Col>

            {/* --- TEST ORDERS (mảng) --- */}
            <Col xs="12">
                <div className="spaces fw-5 mb-4">
                    <span className="d-inline-block spaces min-w-130 fw-bold">
                        Xét nghiệm:
                    </span>
                </div>
                {selectedSheetDetail?.testOrders?.length > 0 ? (
                    selectedSheetDetail?.testOrders.map((x: any, i: number) => (
                        <div key={i} className="spaces fw-4 mb-4 text-truncate ms-3">
                            • {`[${x?.term?.code}] ${x?.term?.name} ${x?.term?.obs?.value ? `- (${x.term.obs.value})` : ""}`}
                            {x?.term?.subs?.length && x?.term?.subs.map((item: any, index: number) => (
                                <div key={index} className="spaces fw-4 mb-4 text-truncate ms-5">
                                    - {`[${item?.code}] ${item?.name} ${item?.obs?.value ? `- (${item.obs.value})` : ""}`}
                                </div>
                            ))}
                        </div>
                    ))
                ) : (
                    <div className="spaces fw-4 ms-3">Không có</div>
                )}
            </Col>

            {/* --- RISPACS ORDERS (mảng) --- */}
            <Col xs="12">
                <div className="spaces fw-5 mb-4">
                    <span className="d-inline-block spaces min-w-130 fw-bold">
                        Chẩn đoán hình ảnh:
                    </span>
                </div>
                {selectedSheetDetail?.risPacsOrders?.length > 0 ? (
                    selectedSheetDetail?.risPacsOrders.map((x: any, i: number) => (
                        <div key={i} className="spaces fw-4 mb-4 text-truncate ms-3">
                            • {`[${x?.term?.code}] ${x?.term?.name} ${x?.term?.obs?.value ? `- (${x.term.obs.value})` : ""}`}
                        </div>
                    ))
                ) : (
                    <div className="spaces fw-4 ms-3">Không có</div>
                )}
            </Col>

            {/* --- SURGERY ORDERS (mảng) --- */}
            <Col xs="12">
                <div className="spaces fw-5 mb-4">
                    <span className="d-inline-block spaces min-w-130 fw-bold">
                        Chuyên khoa:
                    </span>
                </div>
                {selectedSheetDetail?.surgeryOrders?.length > 0 ? (
                    selectedSheetDetail?.surgeryOrders.map((x: any, i: number) => (
                        <div key={i} className="spaces fw-4 mb-4 text-truncate ms-3">
                            • {`[${x?.term?.code}] ${x?.term?.name} ${x?.term?.obs?.value ? `- (${x.term.obs.value})` : ""}`}
                        </div>
                    ))
                ) : (
                    <div className="spaces fw-4 ms-3">Không có</div>
                )}
            </Col>

            {/* --- DRUG ORDERS (mảng) --- */}
            <Col xs="12">
                <div className="spaces fw-5 mb-4">
                    <span className="d-inline-block spaces min-w-130 fw-bold">
                        Thuốc:
                    </span>
                </div>
                {selectedSheetDetail?.drugOrders?.length > 0 ? (
                    selectedSheetDetail?.drugOrders.map((x: any, i: number) => (
                        <div key={i} className="spaces fw-4 mb-4 text-truncate ms-3">
                            • {x}
                        </div>
                    ))
                ) : (
                    <div className="spaces fw-4 ms-3">Không có</div>
                )}
            </Col>

            {/* --- SUPPLY ORDERS (mảng) --- */}
            <Col xs="12">
                <div className="spaces fw-5 mb-4">
                    <span className="d-inline-block spaces min-w-130 fw-bold">
                        Vật tư:
                    </span>
                </div>
                {selectedSheetDetail?.supplyOrders?.length > 0 ? (
                    selectedSheetDetail?.supplyOrders.map((x: any, i: number) => (
                        <div key={i} className="spaces fw-4 mb-4 text-truncate ms-3">
                            • {x}
                        </div>
                    ))
                ) : (
                    <div className="spaces fw-4 ms-3">Không có</div>
                )}
            </Col>

        </Row>
    )
}

export default ThongTinPhieuKhamBenh